import {
  IconAi,
  IconApproval,
  IconCaution,
  Tag,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from '../../columns.module.scss';

export type StatusTagIconType = 'ai' | 'caution' | 'approval';

export type StatusTagInfo = {
  status: 'success' | 'default' | 'warning' | 'error';
  label: string;
  icon?: boolean;
  customIcon?: ReactNode;
  iconType?: StatusTagIconType;
  tooltip?: string;
};

const ICON_MAP: Record<StatusTagIconType, ReactNode> = {
  ai: <IconAi size={12} />,
  caution: <IconCaution size={12} />,
  approval: (
    <IconApproval
      size={12}
      className={styles['receivedInvoiceIdIconApplied']}
    />
  ),
};

export const ProcessingStatusTag: FC<{
  statusTagsInfo: StatusTagInfo[];
}> = ({ statusTagsInfo }) => {
  const cx = classnames.bind(styles);
  if (statusTagsInfo.length === 0) {
    return null;
  }

  return (
    <div className={cx('statusTagsContainer')}>
      {statusTagsInfo.map((tagInfo, index) => {
        const tag = (
          <Tag
            key={index}
            status={tagInfo.status}
            closable={false}
            outline={false}
            className={cx('statusTag')}
            size='small'
            icon={tagInfo.icon}
            customIcon={
              tagInfo.iconType ? ICON_MAP[tagInfo.iconType] : tagInfo.customIcon
            }
          >
            {tagInfo.label}
          </Tag>
        );
        return tagInfo.tooltip ? (
          <Tooltip key={index} title={tagInfo.tooltip}>
            <span>{tag}</span>
          </Tooltip>
        ) : (
          tag
        );
      })}
    </div>
  );
};
